import { Typography } from '@mui/material';
import { TERMS_PDF_URL } from '../terms.constants';
import { TermsComponentStyled } from './termsComponent.styled';

const TermsComponent = () => {
  return (
    <TermsComponentStyled>
      <Typography variant="h3">Terms and Conditions</Typography>
      <iframe
        src={TERMS_PDF_URL}
        className="iframe"
        title="Terms and Conditions"
      ></iframe>
    </TermsComponentStyled>
  );
};

export default TermsComponent;

